import React from 'react';
import TextField from 'components/library/TextField';
import MaterialUiField from '../MaterialUiField';

const TimeField = ({ ...props }) => (
  <MaterialUiField {...props} muiComponent={TextField} type="time" defaultValue="" />
);

export default TimeField;
